import { isValid, parse } from 'date-fns';
import { constant } from './constant';

export const ObjectCreate = ({ data, key, value }) => {
	return data?.map((item) => {
		return {
			key: item[key],
			value: `${item[value]}`,
		};
	});
};

export const getFormattedDateTime = () => {
	const now = new Date();
	const year = now.getFullYear();
	const month = String(now.getMonth() + 1).padStart(2, '0');
	const day = String(now.getDate()).padStart(2, '0');
	const hours = String(now.getHours()).padStart(2, '0');
	const minutes = String(now.getMinutes()).padStart(2, '0');
	return `${year}-${month}-${day}T${hours}:${minutes}`;
};

export const emailIsValid = (email) => {
	return constant.emailRegex.test(email);
};

export const validatePhoneNumber = (phoneNumber) => {
	const phoneRegex = /^(\+\d{1,3}[- ]?)?\d{10}$/;

	if (phoneRegex.test(phoneNumber)) {
		return true;
	} else {
		return false;
	}
};

export const validatePANCard = (pan) => {
	return constant.panCardRegex.test(pan);
};

export const validateGSTNumber = (gst) => {
	return constant.gstRegex.test(gst);
};

export const validDrugLicenseNumber = (drugNumber) => {
	return constant.drugLicenseRegex.test(drugNumber);
};

const isEmpty = (value) => {
	return (
		value === null ||
		value === undefined ||
		value === '' ||
		(Array.isArray(value) && value.length === 0) ||
		(typeof value === 'object' && Object.keys(value).length === 0)
	);
};

export const isAllValuesEmpty = (obj) => {
	return Object.values(obj).every(isEmpty);
};
export const stringToBool = (value) => {
	if (typeof value === 'boolean') return value;
	if (typeof value !== 'string') return false;
	return value.toLowerCase() === 'true';
};

export const getFilterType = (type) =>{
	switch(type){
		case 'Today':
			return 'Today';
		case 'week':
			return 'This Week';
		case 'month':
			return 'This Month';
		case 'quarter':
			return 'This Quarter';
		case 'year':
			return 'This Year';
		case 'fiscal':
			return 'This Fiscal Year';
		case 'custom':
			return 'Custom Date';
		default:
				return 'All';
	}
}

export const formatTitle = (text) => {
	return text
		.replace(/[-_]/g, ' ') // convert - and _ to space
		.replace(/\s+/g, ' ') // remove extra spaces
		.trim() // trim spaces
		.replace(/\b\w/g, (char) => char.toUpperCase()); // capitalize every word
};
export const getDocName = (doc) => {
	if (doc) {
		return doc.split('/').pop();
	}
	return '';
};

export const usageOverviewStatusText = (percentage) => {
	switch (true) {
		case percentage >= 100:
			return 'Limit Reached';
		case percentage >= 80:
			return 'Near Limit';
		case percentage >= 0:
			return 'OK';
		default:
			return 'OK';
	}
};

export const usageOverviewStatusColor = (percentage) => {
	switch (true) {
		case percentage >= 100:
			return {
				text: 'text-danger',
				bg: 'bg-danger-subtle',
				badge: 'badge-danger',
			};
		case percentage >= 80:
			return {
				text: 'text-warning',
				bg: 'bg-warning-subtle',
				badge: 'badge-warning',
			};
		case percentage >= 0:
		case percentage < 80:
			return {
				text: 'text-success',
				bg: 'bg-success-subtle',
				badge: 'badge-success',
			};
		default:
			return {
				text: 'text-success',
				bg: 'bg-success-subtle',
				badge: 'badge-success',
			};
	}
};

export const parseDate = (value) => {
  if (!value) return null;
  const date = parse(value, "dd/MM/yyyy", new Date());

  return isValid(date) ? date : null;
};
